import { render } from "./RoutesTable.vue?vue&type=template&id=3211afd8"
import script from "./RoutesTable.vue?vue&type=script&lang=js"
export * from "./RoutesTable.vue?vue&type=script&lang=js"

import "./RoutesTable.vue?vue&type=style&index=0&id=3211afd8&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Itineraries/RoutesTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3211afd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3211afd8', __exports__)) {
    console.log('reload')
    api.reload('3211afd8', __exports__)
  }
  
  module.hot.accept("./RoutesTable.vue?vue&type=template&id=3211afd8", () => {
    console.log('re-render')
    api.rerender('3211afd8', render)
  })

}


export default __exports__